import { componentWithFG } from '@atlaskit/platform-feature-flags-react';

import { ShortcutMenuItemMemoed, ShortcutMenuItemRaw } from './raw';
export type { ShortcutMenuItemProps } from './raw';

export const ShortcutMenuItem = componentWithFG(
	'navx-3138-gas-menu-rendering-perf-fix',
	ShortcutMenuItemMemoed,
	ShortcutMenuItemRaw,
);
